import React from "react";
import Purchase from "../../components/custom/Purchase/Index";

const Index = () => {
  return (
    <div>
      <Purchase />
    </div>
  );
};

export default Index;
